var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 72,
    viewBox: "0 0 96 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_18013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 35.6 22 24.2h-5.6L5 36V24.2h-5v23.6h5v-5.6l3-3 7 8.6h6l-9-11.3-.7-1Z",
    fill: "#0052FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 34.7a9.2 9.2 0 0 0-8-4.1 9.1 9.1 0 0 0-8.3 4.6c-.7 1.2-1 2.6-1 4.1 0 5 4 8.7 9.3 8.7 5.4 0 9.3-3.6 9.3-8.7 0-1.8-.4-3.3-1.3-4.6Zm-8 9.3c-2.4 0-4.3-1.8-4.3-4.7 0-2.5 1.4-4.2 3.3-4.6a4.7 4.7 0 0 1 1.7 0c2.1.3 3.6 2 3.6 4.6 0 3-1.8 4.7-4.3 4.7Z",
    fill: "#0052FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 30.8h-5v17h5v-17Z",
    fill: "#0052FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 30.6c-2.3 0-4.3.8-5.6 2.2v-2h-4.7v17h5v-8.4c0-1.2.2-2.2.7-3 .7-1 1.9-1.6 3.3-1.6 2 0 3.1 1 3.4 3.2v9.8h2.7l2.3-3.1V38c0-5.2-3-7.5-7-7.5Z",
    fill: "#0052FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 24 71.3 47.9h7.5l2.2-3.2 12.5-17.8 2-2.7Z",
    fill: "url(#paint0_linear_622_18013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.3 24-.7 1.2L75.4 42l-4.1 5.8L95.4 24h-7Z",
    fill: "url(#paint1_linear_622_18013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93 43.6-.3-.4c-.2-.4-.6-.6-1-.6h-5.8c-.2 0-.3.1-.4.3L96 47.8l-3-4.2Z",
    fill: "#F69300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5 42.9v.5l1.2 1.7 1.7 2.7H96l-10.5-5Z",
    fill: "url(#paint2_linear_622_18013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82 28.5-1.7-2.7-1.2-1.7h-7.4l10.2 5c.2 0 .3-.4.2-.6Z",
    fill: "url(#paint3_linear_622_18013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.7 24 3.1 4.7c.3.4.7.6 1.2.6h5.6l.3-.1L71.7 24Z",
    fill: "#F69300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m44 29.5-1-.7.5-.4c0-.8.3-1.6 1-2.3.6-.8 1.5-1.2 2.2-1.2l.5-.4.7 1c.5.7.3 2-.7 3.1-1 1.2-2.4 1.5-3.2 1Z",
    fill: "url(#paint4_linear_622_18013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6 28c1-1.3 1.3-2.9.5-3.6-.9-.7-2.4-.3-3.5.9s-1.3 2.8-.5 3.5c.8.8 2.4.4 3.5-.9Z",
    fill: "url(#paint5_linear_622_18013)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6 28c1-1.3 1.3-2.9.5-3.6-.9-.7-2.4-.4-3.5.9-1.1 1.2-1.3 2.8-.5 3.5.9.8 2.4.4 3.5-.8Z",
    fill: "#0052FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_18013",
    x1: 90,
    y1: 30.4,
    x2: 80.7,
    y2: 41.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_622_18013",
    x1: 71.3,
    y1: 35.9,
    x2: 95.4,
    y2: 35.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_622_18013",
    x1: 85.4,
    y1: 45.3,
    x2: 96,
    y2: 45.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_622_18013",
    x1: 71.7,
    y1: 26.6,
    x2: 82.2,
    y2: 26.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_622_18013",
    x1: 48,
    y1: 25.7,
    x2: 44.4,
    y2: 29.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3372F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3372F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#80DBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3372F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3372F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_622_18013",
    x1: 53.3,
    y1: 25.7,
    x2: 52.4,
    y2: 26.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F1F8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_18013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 24,
    fill: "white",
    transform: "translate(0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKLogo);
export default __webpack_public_path__ + "static/media/kLogo.451ea5c1c4dff2e9947bc8a4dd95c542.svg";
export { ForwardRef as ReactComponent };